import React from 'react';

import Logo from '../assets/logo4.jpeg'; 
import logo2 from '../assets/logo3.jpeg';
import banner from '../assets/banner.png';
import './style.css'
import { useNavigate } from 'react-router-dom';



const Navbar = () => {

  const handleRefresh = () => {
   window.location.href = '/';
};
  return (
    <nav className="navbar-home">
      <div className="navbar-container-home">
        <div className="logo-home">
      <img 
        src={Logo}
        alt="Logo" 
        className="logo-img"
        onClick={handleRefresh}
        style={{ cursor: 'pointer' }}

          />
        </div>

        <div className="main-banner">
          <img 
            src={banner}
            alt="Main Banner" 
            className="banner-img"
            // onClick={()=>navigate('/')}
          />
        </div>
     
      </div>
    </nav>
  );
};

export default Navbar;

